import _classCallCheck from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var defError = function defError(prefix) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (msg) {
    return msg !== undefined ? ": " + msg : "";
  };
  return (
    /*#__PURE__*/
    function (_Error) {
      _inherits(_class, _Error);

      function _class(msg) {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, prefix(msg) + suffix(msg)));
      }

      return _class;
    }(_wrapNativeSuper(Error))
  );
};